import styled from 'styled-components';
import watermark from '../../assets/images/watermark.svg';

export const Wrapper = styled.div`
  width: 100%;
  max-width: 270px;
  /* height: 370px; */
  height: 400px;
  border-radius: 16px;
  overflow: hidden;
  cursor: pointer;
  position: relative;
  display: flex;
  flex-direction: column;

  &::before {
    content: '';
    position: absolute;
    inset: 0;
    background-image: url(${watermark});
    background-repeat: no-repeat;
    background-position: center;
    background-size: contain;
    opacity: 0.6;
    pointer-events: none;
    z-index: 1;
  }

  &:hover {
    transition: 0.7s;
    opacity: 0.8;
  }

  video,
  > img {
    width: 100%;
    height: 100%;
    border-radius: 16px;
    object-fit: cover;
  }
`;

export const Button = styled.button`
  width: 36px;
  height: 36px;
  display: flex;
  align-items: center;
  justify-content: center;
  position: absolute;
  top: 0;
  right: 0;
  background-color: ${({ theme }) => theme.colors.outher.danger};
  border: 0;
  border-radius: 100%;
  z-index: 2;

  &:hover {
    transition: 0.7s;
    opacity: 0.8;
  }
`;

export const IconPlayer = styled.div`
  width: 100%;
  height: 100%;
  position: absolute;
  display: flex;
  align-items: center;
  justify-content: center;

  img {
    width: 100%;
    max-width: 36px;
    opacity: 0.9;
    /* height: 28px; */
  }
`;
